import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseApiService } from './base-api.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PolicyService extends BaseApiService<any> {
  constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/policies`);
  }

  getPrivacyPolicy() {
    return super.getRaw('Privacy');
  }

  getTermsAndConditions() {
    return super.getRaw('TermsAndConditions');
  }

  getAssessmentAppPrivacyPolicy() {
    return super.getRaw('PrivacyAssessment');
  }

  getAssessmentAppTermsAndConditions() {
    return super.getRaw('TermsAndConditionsAssessment');
  }
}
